// extracted by mini-css-extract-plugin
export default {"myPhoto":"About_myPhoto__GQ9Fb"};